// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  ADD_ACCOUNT,
  UPDATE_ACCOUNT_OPERATION,
} from './constants'

export function addAccount (): Action<> {
  return {
    type: ADD_ACCOUNT,
  }
}

export function updateAccountOperation (payload: Object): Action<> {
  return {
    type: UPDATE_ACCOUNT_OPERATION,
    payload,
  }
}
